import {RadioField} from '@/components/commons/radio-field/RadioField'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {FormFieldBox} from '@/components/ui/form-atoms/FormAtoms'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {InputHelpText} from '@/components/ui/input-help-text/InputHelpText'
import {Label} from '@/components/ui/label/Label'
import {useTranslation} from '@/translations/i18n'
import {ChangeEventHandler} from 'react'
import {FieldError} from 'react-hook-form'

interface ProtectedCategoryRadioButtonsProps {
    name: string
    value: 'belonging' | 'notBelonging'
    label: string
    onChange: ChangeEventHandler<HTMLInputElement>
    error?: FieldError
}

export const ProtectedCategoryRadioButtons = ({
    name,
    value,
    label,
    onChange,
    error
}: ProtectedCategoryRadioButtonsProps) => {
    const {t} = useTranslation()
    return (
        <Flexbox direction="column" gap={1.5} fullWidth>
            <Label>{label}</Label>
            <Flexbox fullWidth direction="column" gap={1.5}>
                <Grid columns={2} gap={4} fullWidth>
                    <FormFieldBox spanColumn={1} isSelected={value == 'belonging'} hasError={!!error}>
                        <RadioField
                            label={t('patients:belonging')}
                            name={name}
                            checked={value == 'belonging'}
                            onChange={onChange}
                            value="belonging"
                        />
                    </FormFieldBox>
                    <FormFieldBox spanColumn={1} isSelected={value == 'notBelonging'} hasError={!!error}>
                        <RadioField
                            label={t('patients:not_belonging')}
                            name={name}
                            checked={value == 'notBelonging'}
                            onChange={onChange}
                            value="notBelonging"
                        />
                    </FormFieldBox>
                </Grid>
                {error?.message && <InputHelpText error={error.message} />}
            </Flexbox>
        </Flexbox>
    )
}
